module.exports = __webpack_public_path__ + "static/img/ThatDay.023f418.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/ThatDay.jpg
// module id = LTHE
// module chunks = 1